import React, { useEffect, useState } from "react";

import { useGetReferralValues, useTranslation } from "utils";

import { Button, FunkyCard, Icon } from "components";

import { ReferralDrawer } from "pages/app/dashboard/components/ReferralDrawer";

export const ReferralBanner = ({ referralToken, showDrawer }) => {
  const { t } = useTranslation("user");

  const [loading, setLoading] = useState(false);
  const [drawerIsVisible, setDrawerIsVisible] = useState(showDrawer || false);

  const { referralValues, referralValuesLoading } = useGetReferralValues();
  const { referralValue, firstYearlyDataReferralValue } = referralValues;

  useEffect(() => {
    if (!referralValuesLoading) {
      setLoading(false);
    }
  }, [referralValuesLoading]);

  return (
    !loading && (
      <>
        <FunkyCard
          image={"/images/misc/referral.jpg"}
          content={
            <h1 className="white-text">
              {t("referralBanner.description", {
                referralValueFirst: referralValue,
                referralValueSecond: firstYearlyDataReferralValue,
                referralValueSum: referralValue + firstYearlyDataReferralValue,
              })}
            </h1>
          }
          foot={
            <Button type="primary white" onClick={() => setDrawerIsVisible(true)}>
              {t("referralBanner.button")} <Icon iconName="tabler/arrow-right" className="icon inline" />
            </Button>
          }
        />
        <ReferralDrawer
          referralToken={referralToken}
          referralValue={referralValue}
          firstYearlyDataReferralValue={firstYearlyDataReferralValue}
          visible={drawerIsVisible}
          onClose={() => setDrawerIsVisible(false)}
        />
      </>
    )
  );
};

export default ReferralBanner;
